// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bRxF","delete":"styles_delete__tlnYj","update":"styles_update__29dpW","add":"styles_add__1mAt9"};